
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/drafts",
      function () {
        return require("private-next-pages/dashboard/drafts/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/drafts"])
      });
    }
  